import type { NavigateFunction } from 'react-router-dom';

export const MODULE_BACK_STORAGE_KEY = 'eone.moduleBackTo';

export interface ModuleNavigationState {
  moduleBackTo?: string;
}

type SharedRouteConfig = {
  routePrefix: string;
  defaultModule: string;
  validModules: readonly string[];
};

/** Rutas bajo /tesoreria accesibles desde más de un módulo del menú. */
export const SHARED_MODULE_ROUTES: SharedRouteConfig[] = [
  {
    routePrefix: '/tesoreria/recibos',
    defaultModule: '/tesoreria',
    validModules: ['/ventas', '/tesoreria'],
  },
  {
    routePrefix: '/tesoreria/orden-pago',
    defaultModule: '/tesoreria',
    validModules: ['/compras', '/tesoreria'],
  },
];

export function matchesSharedModuleRoute(pathname: string): SharedRouteConfig | null {
  for (const config of SHARED_MODULE_ROUTES) {
    if (pathname === config.routePrefix || pathname.startsWith(`${config.routePrefix}/`)) {
      return config;
    }
  }
  return null;
}

export function persistModuleBackTo(modulePath: string): void {
  sessionStorage.setItem(MODULE_BACK_STORAGE_KEY, modulePath);
}

export function readModuleBackTo(): string | null {
  return sessionStorage.getItem(MODULE_BACK_STORAGE_KEY);
}

export function clearModuleBackTo(): void {
  sessionStorage.removeItem(MODULE_BACK_STORAGE_KEY);
}

function isValidModuleBackTarget(modulePath: string, config: SharedRouteConfig): boolean {
  return config.validModules.includes(modulePath);
}

/** Resuelve el hub de módulo al que debe volver el botón "Volver al Menu". */
export function resolveModuleBackForPath(
  pathname: string,
  stateModuleBack?: string | null,
): string | null {
  const config = matchesSharedModuleRoute(pathname);
  if (!config) return null;

  const candidates = [stateModuleBack, readModuleBackTo()].filter(Boolean) as string[];
  for (const candidate of candidates) {
    if (isValidModuleBackTarget(candidate, config)) {
      return candidate;
    }
  }
  return config.defaultModule;
}

export function navigateWithModuleBack(
  navigate: NavigateFunction,
  targetPath: string,
  modulePath: string,
): void {
  persistModuleBackTo(modulePath);
  navigate(targetPath, { state: { moduleBackTo: modulePath } satisfies ModuleNavigationState });
}

export function maybePersistModuleBackOnNavigate(targetPath: string, parentModulePath: string): void {
  if (matchesSharedModuleRoute(targetPath)) {
    persistModuleBackTo(parentModulePath);
  }
}
